import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const PrivateRouteWiki = ({
  component: Component,
  auth: { wikiisAuthenticated, wikiloading },
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      wikiisAuthenticated ? <Component {...props} /> : <Redirect to="/wiki/billing" />
    }
  />
);

PrivateRouteWiki.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps)(PrivateRouteWiki);